// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-largeOnConfined-text-302530fc"};